import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f2ad9d1"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "settings_button" };
const _hoisted_2 = {
    key: 0,
    class: "settings setting_menu"
};
const _hoisted_3 = { class: "list name" };
const _hoisted_4 = { class: "subject" };
const _hoisted_5 = { class: "list" };
const _hoisted_6 = { class: "flex order" };
const _hoisted_7 = { class: "description" };
const _hoisted_8 = { class: "list" };
const _hoisted_9 = { class: "flex" };
const _hoisted_10 = { class: "description" };
import UserInfo from '@/materials/atoms/UserInfo.vue';
import { ref } from 'vue';
import TimeZoneSelection from '@/materials/molecules/TimeZoneSelection.vue';
import Toggle from '@/materials/atoms/Toggle.vue';
import { useSettings } from '@/logics/settings';
import { useStore } from '@/store/store';
import { useMessage } from '@/const/messages';
import Logout from './Logout.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        userInfo: null
    },
    setup(__props) {
        var _a;
        const props = __props;
        const { putUserSettings } = useSettings();
        const userName = ref(((_a = props.userInfo) === null || _a === void 0 ? void 0 : _a.email) || '');
        const store = useStore();
        const { format, USER_SETTINGS_MESSAGES } = useMessage();
        const onOrderConfirmChange = (value) => {
            store.state.userSettings.isOrderLeave = value;
            putUserSettings({
                isOrderLeave: value,
            });
        };
        const onCancelConfirmChange = (value) => {
            store.state.userSettings.isCancelLeave = value;
            putUserSettings({
                isCancelLeave: value,
            });
        };
        const onTimeZoneChange = (value) => {
            store.state.userSettings.localTime = value;
            putUserSettings({
                localTime: value,
            });
        };
        const isShowMenu = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "outer",
                onMouseover: _cache[0] || (_cache[0] = ($event) => (isShowMenu.value = true)),
                onMouseleave: _cache[1] || (_cache[1] = ($event) => (isShowMenu.value = false))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(UserInfo, {
                        userName: userName.value.substring(0, 1).toUpperCase()
                    }, null, 8, ["userName"])
                ]),
                (isShowMenu.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(userName.value), 1)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(Toggle, {
                                    id: "settings_order",
                                    isInitCheck: Boolean(_unref(store).state.userSettings.isOrderLeave),
                                    onChange: onOrderConfirmChange
                                }, null, 8, ["isInitCheck"]),
                                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(format)(_unref(USER_SETTINGS_MESSAGES).ORDER_CONFIRM)), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(Toggle, {
                                    id: "settings_cancel",
                                    "is-init-check": Boolean(_unref(store).state.userSettings.isCancelLeave),
                                    onChange: onCancelConfirmChange
                                }, null, 8, ["is-init-check"]),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(format)(_unref(USER_SETTINGS_MESSAGES).CANCEL_CONFIRM)), 1)
                            ])
                        ]),
                        _createVNode(TimeZoneSelection, {
                            class: "list timezone",
                            "init-zone": String(_unref(store).state.userSettings.localTime),
                            onChange: onTimeZoneChange
                        }, null, 8, ["init-zone"]),
                        _createVNode(Logout, { class: "logout list" })
                    ]))
                    : _createCommentVNode("", true)
            ], 32));
        };
    }
});
